<template>
  <!--
        作者：kmdshop
        时间：2019-10-25
        描述：权限-管理员列表
    -->
  <div class="user">
    <!--添加管理员-->
    <div class="common-level-rail">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item><el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/auth/user/add'">添加管理员</el-button></el-form-item>
        

      <el-form-item label="角色">
        <el-select v-model="formInline.role_id" placeholder="-请选择角色-">
           <el-option v-for="item in role" :value="item.role_id" :key="item.role_id" :label="item.role_name" ></el-option>
        </el-select>
      </el-form-item>
        
        <el-form-item label="用户名" style="margin-left: 50px"><el-input v-model="formInline.user_name" placeholder="请输入用户名或姓名"></el-input></el-form-item>
        <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
       
       <div>
          如果需要添加供应商账号，请前往供应商去添加

       </div>
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="shop_user_id" label="管理员ID"></el-table-column>
          <el-table-column prop="name" label="用户名/姓名">
            <template slot-scope="scope">
              {{scope.row.user_name}} <br/>
              {{scope.row.real_name}} <br/>
            </template>
          </el-table-column>
          <el-table-column prop="role.role_name" label="所属角色">
            <template slot-scope="scope">
              <div v-if="scope.row.is_super == 0">
                <span class="mr10 green" v-for="(item, index) in scope.row.userRole" :key="index"
                v-if=" item.role && item.role.role_name"
                >{{ item.role.role_name }}</span>
              </div>
              <div class="gray" v-if="scope.row.is_super == 1">
                超级管理员
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="添加时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="300">
            <template slot-scope="scope">
              <el-button style="padding-left: 0px !important;" v-if="scope.row.is_super < 1" @click="loginClick(scope.row)" type="text" size="small" >登录</el-button>
              <el-button style="padding-left: 0px !important;" v-if="scope.row.is_super < 1" @click="cityClick(scope.row)" type="text" size="small" >管理城市</el-button>
              <el-button style="padding-left: 0px !important;" v-if="scope.row.is_super < 1" @click="pfdClick(scope.row)" type="text" size="small" >可查看的供应商</el-button>
              <el-button style="padding-left: 0px !important;" v-if="scope.row.is_super < 1" @click="editClick(scope.row)" type="text" size="small" v-auth="'/auth/user/edit'">编辑</el-button>
              <el-button style="padding-left: 0px !important;" v-if="scope.row.is_super < 1" @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/auth/user/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open="open_add" :type="type" :roleList="roleList"  @close="closeAdd"></Add>

    <Edit :open="open_edit" :type="type"  :roleList="roleList" :shop_user_id="curModel.shop_user_id"  @close="closeEdit"></Edit>
    <City :open_add="open_city" v-if="open_city"   :shop_user_id="curModel.shop_user_id"  @close="closeEdit"></City>
    <Pfd :open_add="open_pfd" v-if="open_pfd"   :shop_user_id="curModel.shop_user_id"  @close="closeEdit"></Pfd>

  </div>
</template>

<script>
import AuthApi from '@/api/auth.js';
import Add from './dialog/Add.vue';
import Edit from './dialog/Edit.vue';
import City from './dialog/city.vue';
import Pfd from './dialog/pfd.vue';
import UserApi from "@/api/user.js";
import { setCookie, delCookie, getCookie, deleteSessionStorage } from '@/utils/base.js';
import router, { resetRouter} from '@/router';
export default {
  components: {
    Add,
    Edit,
    City,
    Pfd,
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*角色是否加载完成*/
      role_loading:true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        user_name: '',
        region: '',
        role_id:0,
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      curModel: {},
      /*角色列表*/
      roleList:[],
      // type 类型
      type:"",//pc 后台  mobile  手机端
      role:[],
      open_city:false,

      open_pfd:false
    };
  },
  created() {
    /*获取列表*/
    this.type = '';
    if(this.$route.query.type){
      this.type = this.$route.query.type;
    }
    this.getRole();
    this.getTableList();
    this.getAllrole();
  },
  watch: {
        // 利用watch方法检测路由变化：
        $route: function (to, from) {
          this.type = '';
           if(to.query.type && to.query.type.length > 0){
              this.type = to.query.type;
              this.getTableList();
            }else{
              this.getTableList();
            }
        }
    },
  methods: {
    loginClick(item){
      var Params = {
            username: item.user_name,
            password: 123456,
          };
        /*调用登录接口*/
      var self = this;
        UserApi.loginOut({}, true)
            .then(data => {
              /*删除登录状态*/
              delCookie('isLogin');
              delCookie('token');
              /*删除基本信息*/
              delCookie('baseInfo');
              /*删除用户菜单*/
              deleteSessionStorage('rolelist');
              /*删除用户权限*/
              deleteSessionStorage('authlist');
              /*返回登录页*/
              self.$router.replace({ path: '/login' });
              /*删除stores数据*/
              self.$store.commit('user/setState', { key: 'roles', val: null });
              // /*刷新页面*/
              // location.reload();


              UserApi.login(Params, true)
                .then((res) => {
                  console.log(res);
                  if (res.code == 1) {
                    /*保存个人信息*/
                    setCookie("userinfo", res.data);
                    if(res.data.supply){
                      setCookie("is_supply", 1);
                    }else{
                      setCookie("is_supply", 0);
                    }
                    if(res.data.token != undefined){
                      setCookie("token", res.data.token);
                    }
                    /*设置一个登录状态*/
                    setCookie("isLogin", true);
                    self.pathroute = res.data.path;
                    console.log(self.pathroute);
                    /*跳转到首页*/
                    if (self.pathroute != "") {
                      self.$router.push({ path: self.pathroute });
                    } else {
                      self.$router.push({ path: "/" });
                    }
                  } else {
                    self.$message({
                      message: "登录失败",
                      type: "error",
                    });
                  }
                })
                .catch((error) => {

                });

            })
            .catch(error => {});
      
      
   
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList(searchParams='') {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.type = self.type
      if(searchParams!=''){
        Params.user_name = searchParams;
      }
      Params.role_id = self.formInline.role_id
      AuthApi.userList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*获取角色*/
    getRole() {
      let self = this;
      AuthApi.getRole({
      
      })
        .then(data => {
          self.role = data.data;
        })
        .catch(error => {
        });
    },
    /*获取角色*/
    getAllrole() {
      let self = this;
      AuthApi.userAddInfo({
        type:self.type
      })
        .then(data => {
          self.role_loading = false;
          self.roleList = data.data.roleList;
        })
        .catch(error => {
          self.role_loading = false;
        });
    },
    /*搜索查询*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let searchParams = self.formInline.user_name;
      self.getTableList(searchParams);
    },

    /*打开添加*/
    addClick() {
      if(!this.role_loading){
         this.open_add=true;
      }
    },

    /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      if(e.type=='success'){
        this.getTableList();
      }
    },

    /*打开编辑*/
    editClick(row) {
      this.curModel=row;
      this.open_edit=true;
    },    /*打开编辑*/
    cityClick(row) {
      this.curModel=row;
      this.open_city=true;
    },
    pfdClick(row) {
      this.curModel=row;
      this.open_pfd=true;
    },

    /*关闭添加*/
    closeEdit(e){
      this.open_edit=false;
      this.open_city = false;
      this.open_pfd = false;
      if(e.type=='success'){
        this.getTableList();
      }
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          AuthApi.userDelete(
            {
              shop_user_id: row.shop_user_id
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，该管理员删除成功',
                  type: 'success'
                });
                //刷新页面
                self.getTableList();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/auth/user/index.vue